import { getFomrInfo } from '@/api/connectedCar/dealerInfo'
import { connectedCarInfo } from '@/api/connectedCar/step1'
export default {
  state: {
    common: {
      onetAppfFomNo: '',
      dealCd: '',
      opmkNo: '',
      itemSn: '',
      usimMdlNm: '',
      usimSn: '',
      naviSn: '',
      uiccId: '',
      imei: '',
      ctn: '',
      saleView: '',
      trmMdlCd: '',
      trmMdlNm: '',
      oldItem: '',
      payYn: '',
      phonePayStyleCd: null,
      opmkEntrKdCd: '',
      tradeid: '',
      smsval: '',
      onetAutnMthdDivsCd: '',
      entrLoc: ''
    },
    returnUrl: '',
    personalInfo: {
      name: '',
      phoneNo: '',
      birthDay: '',
      certNum: '',
      rec_cert: '',
      r_phoneCorp: ''
    },
    address: {
    },
    dealerInfo: {

    }
  },
  mutations: {
    SET_CONNECTED_CAR_COMMON: (state, common) => {
      state.common = common
    },
    SET_CONNECTED_CAR_PERSON: (state, person) => {
      state.personalInfo = person
    },
    SET_CONNECTED_CAR_ADDRESS: (state, address) => {
      state.address = address
    },
    SET_CONNECTED_DEALER_INFO: (state, dealear) => {
      state.dealerInfo = dealear
    },
    SET_RETURN_URL: (state, returnUrl) => {
      state.returnUrl = returnUrl
    },
    SET_DEVICE_INFO: (state, deviceInfo) => {
      state.common.itemSn = deviceInfo.itemSn
      state.common.ctn = deviceInfo.ctn
      state.common.usimMdlNm = deviceInfo.usimMdlNm
      state.common.usimSn = deviceInfo.usimSn
    }
  },
  actions: {
    saveDealerInfo({ commit, dispatch }, param) {
      return new Promise((resolve, reject) => {
        getFomrInfo(param.agentId, param.formId, param.openmktCd).then(res => {
          commit('SET_CONNECTED_DEALER_INFO', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    saveConnectedCarInfo({commit, dispatch}, param) {
     return new Promise((resolve, reject) => {
      connectedCarInfo(param.formId, param.agentId, param.openmktCd, param.itemSn, param.naviSn, param.uiccId, param.usimMdlNm, param.usimSn, param.imei, param.ctn, param.entrLoc).then(res => {
        commit('SET_CONNECTED_CAR_COMMON', res.data)
        resolve()
      }).catch(error => {
        reject(error)
      })
      
     })
    },
    setReturnUrl({ commit, dispatch }, returnUrl) {
      commit('SET_RETURN_URL', returnUrl)
    },
    setConnectedCarPerson({ commit }, person) {
      commit('SET_CONNECTED_CAR_PERSON', person)
    },
  }
}

// this.$store.dispatch('SetMsg', '테스트 입니다.')
// 가져올때: this.$store.state.ConnectedCar.msg
